module.exports = __webpack_public_path__ + "media/images/indexCenterBanner-7e17abd29c9d7316ab48d044af2d0bc2.png";